export const TEST_ID = 'boundaryFormFields';

export const BOUNDARY_NAME_FIELD_NAME = 'name';
